module.exports = __webpack_public_path__ + "img/seelablog.5f4fe125.png";